module.exports = __webpack_public_path__ + "img/06.a5d98acd.webp";